'use strict';

module.exports = (socialCommerceData) => {
    return {
        namespaced: true,
        state: {
            ...socialCommerceData,
        },
        getters: { },
        actions: { },
        mutations: { }
    };
};
